import React, { useEffect } from 'react'
import Navbar from '../components/navbar/Navbar'
import Header from '../components/header/Header'
import Brands from '../components/brands/brands'
import Projects from '../components/projects/Projects'
import Services from '../components/services/Services'
import Locations from '../components/locations/Locations'
import Footer from '../components/footer/Footer'
import { useLocation } from 'react-router-dom'

const Home = () => {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    // Sadece ana sayfadaysak ve hash varsa
    if (pathname === '/' && hash) {
      // DOM tamamen yüklensin diye küçük bir gecikme
      setTimeout(() => {
        const id = hash.replace('#', '');
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 50);
    }
  }, [hash, pathname]);
  return (
    <div>
     <Navbar/>
     <Header/>
     <Brands/>
     <Projects/>
     <Services/>
     <Locations/>
     <Footer/>
    </div>
  )
}

export default Home
